module.exports = __webpack_public_path__ + "2e68df4862fc1c2883e46c0818f6034d.pdf";